<!-- eslint-disable vue/no-deprecated-v-on-native-modifier -->
<template>
  <div class="py-4 container-fluid">
    <div class="mt-4 row">
      <div class="col-12">
        <div class="card z-index-0" v-if="isLoading">
          <div class="card-body">
            <div class="loader">
              <pulse-loader :loading="isLoading" color="#26336A"></pulse-loader>
            </div>
          </div>
        </div>

        <div class="card md-4" v-else>
          <div class="card-header pb-0">
            <h6>Skonfiguruj swoje konto</h6>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-10 offset-1">
                <form-wizard
                  @on-complete="onComplete"
                  back-button-text="Wróć"
                  next-button-text="Dalej"
                  finish-button-text="Zapisz"
                  ref="wizard"
                  @on-change="handleChange"
                >
                  <tab-content
                    title="Informacje ogólne"
                    :before-change="beforeTabSwitch"
                  >
                    <div class="col-6 offset-3">
                      <argon-input
                        type="text"
                        :v="v$.item.generalInfo.name"
                        v-model="v$.item.generalInfo.name.$model"
                        :submitted="submitted"
                        placeholder="Nazwa organizacji*"
                      />

                      <argon-input
                        type="text"
                        placeholder="NIP*"
                        :v="v$.item.generalInfo.taxId"
                        :submitted="submitted"
                        v-model="v$.item.generalInfo.taxId.$model"
                      />
                      <argon-input
                        type="text"
                        placeholder="REGON*"
                        v-model="v$.item.generalInfo.regon.$model"
                        :v="v$.item.generalInfo.regon"
                        :submitted="submitted"
                      />
                      <argon-input
                        type="text"
                        placeholder="KRS"
                        v-model="v$.item.generalInfo.krs.$model"
                        :v="v$.item.generalInfo.krs"
                        :submitted="submitted"
                      />

                      <div class="mb-4">
                        <label>Forma prawna *</label>

                        <div
                          class="form-check"
                          v-for="i in LegalFormEnum"
                          :key="i.id"
                        >
                          <input
                            class="form-check-input"
                            type="radio"
                            :id="'legalForm' + i.id"
                            name="legalForm"
                            :value="i.id"
                            v-model="item.generalInfo.legalForm.legalFormEnum"
                          />
                          <label
                            class="custom-control-label"
                            :for="'legalForm' + i.id"
                          >
                            {{ i.description }}
                          </label>
                        </div>
                      </div>
                      <argon-input
                        v-if="item.generalInfo.legalForm.legalFormEnum == 10"
                        type="text"
                        placeholder="Jaka?*"
                        v-model="v$.item.generalInfo.legalForm.otherName.$model"
                        :class="{
                          'is-invalid':
                            v$.item.generalInfo.legalForm.otherName.$errors
                              .length,
                        }"
                      />

                      <div class="mb-4">
                        <label>Zasięg działania *</label>

                        <div
                          class="form-check"
                          v-for="i in contractorScopeOfActivitiesEnums"
                          :key="i.id"
                        >
                          <input
                            class="form-check-input"
                            type="radio"
                            :id="'scope' + i.id"
                            name="scope"
                            :value="i.id"
                            v-model="item.generalInfo.scopeOfActivities"
                          />
                          <label
                            class="custom-control-label"
                            :for="'scope' + i.id"
                          >
                            {{ i.description }}
                          </label>
                        </div>
                      </div>
                      <argon-input
                        type="text"
                        placeholder="Numer konta bankowego*"
                        v-model="v$.item.generalInfo.bankAccountNumber.$model"
                        :v="v$.item.generalInfo.bankAccountNumber"
                        :submitted="submitted"
                      />

                      <argon-input
                        type="text"
                        placeholder="Opis działalności organizacji"
                        v-model="item.generalInfo.description"
                      />
                    </div>
                  </tab-content>
                  <tab-content
                    title="Dane kontaktowe"
                    :before-change="beforeTabSwitch2"
                  >
                    <div class="col-6 offset-3">
                      <argon-input
                        type="text"
                        placeholder="Ulica i numer lokalu*"
                        v-model="v$.item.contactInfo.street.$model"
                        :v="v$.item.contactInfo.street"
                        :submitted="submitted2"
                      />
                      <argon-input
                        type="text"
                        placeholder="Kod pocztowy*"
                        v-model="v$.item.contactInfo.postalCode.$model"
                        :v="v$.item.contactInfo.postalCode"
                        :submitted="submitted2"
                      />
                      <argon-input
                        type="text"
                        placeholder="Miejscowość*"
                        v-model="v$.item.contactInfo.city.$model"
                        :v="v$.item.contactInfo.city"
                        :submitted="submitted2"
                      />
                      <argon-input
                        type="text"
                        placeholder="Region*"
                        v-model="v$.item.contactInfo.region.$model"
                        :v="v$.item.contactInfo.region"
                        :submitted="submitted2"
                      />

                      <argon-input
                        type="email"
                        placeholder="Główny adres e-mail organizacji*"
                        v-model="v$.item.contactInfo.emailAddress.$model"
                        :v="v$.item.contactInfo.emailAddress"
                        :submitted="submitted2"
                      />

                      <argon-input
                        type="text"
                        placeholder="Adres strony internetowej"
                        v-model="v$.item.contactInfo.webAddress.$model"
                        :v="v$.item.contactInfo.webAddress"
                        :submitted="submitted2"
                      />
                      <argon-input
                        type="text"
                        placeholder="Numer telefonu*"
                        v-model="v$.item.contactInfo.phoneNumber.$model"
                        :v="v$.item.contactInfo.phoneNumber"
                        :submitted="submitted2"
                      />
                    </div>
                  </tab-content>
                  <tab-content
                    title="Dokumenty organizacji"
                    :before-change="beforeTabSwitch3"
                  >
                    <div class="col-6 offset-3 files mb-6">
                      <p>
                        <strong
                          >Zaświadczenie o posiadanym rachunku bankowym
                          *</strong
                        >
                      </p>
                      <input
                        type="file"
                        style="display: none"
                        ref="fileInput"
                        accept="image/jpeg, application/pdf"
                        @change="onFilePicked($event, 1)"
                      />

                      <p v-if="item.documents.bankAccountStatementId">
                        Plik dodany!
                        <a
                          style="float: right"
                          href="#"
                          @click="item.documents.bankAccountStatementId = null"
                        >
                          <svg
                            width="18"
                            height="21"
                            viewBox="0 0 18 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7 16.7207C7.26522 16.7207 7.51957 16.6153 7.70711 16.4278C7.89464 16.2403 8 15.9859 8 15.7207V9.7207C8 9.45549 7.89464 9.20113 7.70711 9.0136C7.51957 8.82606 7.26522 8.7207 7 8.7207C6.73478 8.7207 6.48043 8.82606 6.29289 9.0136C6.10536 9.20113 6 9.45549 6 9.7207V15.7207C6 15.9859 6.10536 16.2403 6.29289 16.4278C6.48043 16.6153 6.73478 16.7207 7 16.7207ZM17 4.7207H13V3.7207C13 2.92505 12.6839 2.16199 12.1213 1.59938C11.5587 1.03677 10.7956 0.720703 10 0.720703H8C7.20435 0.720703 6.44129 1.03677 5.87868 1.59938C5.31607 2.16199 5 2.92505 5 3.7207V4.7207H1C0.734784 4.7207 0.48043 4.82606 0.292893 5.0136C0.105357 5.20113 0 5.45549 0 5.7207C0 5.98592 0.105357 6.24027 0.292893 6.42781C0.48043 6.61535 0.734784 6.7207 1 6.7207H2V17.7207C2 18.5164 2.31607 19.2794 2.87868 19.842C3.44129 20.4046 4.20435 20.7207 5 20.7207H13C13.7956 20.7207 14.5587 20.4046 15.1213 19.842C15.6839 19.2794 16 18.5164 16 17.7207V6.7207H17C17.2652 6.7207 17.5196 6.61535 17.7071 6.42781C17.8946 6.24027 18 5.98592 18 5.7207C18 5.45549 17.8946 5.20113 17.7071 5.0136C17.5196 4.82606 17.2652 4.7207 17 4.7207ZM7 3.7207C7 3.45549 7.10536 3.20113 7.29289 3.0136C7.48043 2.82606 7.73478 2.7207 8 2.7207H10C10.2652 2.7207 10.5196 2.82606 10.7071 3.0136C10.8946 3.20113 11 3.45549 11 3.7207V4.7207H7V3.7207ZM14 17.7207C14 17.9859 13.8946 18.2403 13.7071 18.4278C13.5196 18.6153 13.2652 18.7207 13 18.7207H5C4.73478 18.7207 4.48043 18.6153 4.29289 18.4278C4.10536 18.2403 4 17.9859 4 17.7207V6.7207H14V17.7207ZM11 16.7207C11.2652 16.7207 11.5196 16.6153 11.7071 16.4278C11.8946 16.2403 12 15.9859 12 15.7207V9.7207C12 9.45549 11.8946 9.20113 11.7071 9.0136C11.5196 8.82606 11.2652 8.7207 11 8.7207C10.7348 8.7207 10.4804 8.82606 10.2929 9.0136C10.1054 9.20113 10 9.45549 10 9.7207V15.7207C10 15.9859 10.1054 16.2403 10.2929 16.4278C10.4804 16.6153 10.7348 16.7207 11 16.7207Z"
                              fill="#F5365C"
                            /></svg
                        ></a>
                      </p>

                      <argon-button
                        v-if="!item.documents.bankAccountStatementId"
                        :disabled="isLoading"
                        full-width
                        color="dark"
                        variant="gradient"
                        class="ma-4"
                        @click.prevent="addBankAccountStatement"
                      >
                        <div
                          class="loader"
                          v-if="isLoadingF1"
                          style="min-height: initial"
                        >
                          <pulse-loader
                            :loading="isLoadingF1"
                            color="#fff"
                          ></pulse-loader>
                        </div>
                        <span class="btn-inner--text" v-if="!isLoadingF1"
                          >Dodaj plik z komputera</span
                        >
                        <span
                          class="btn-inner--icon"
                          v-if="!isLoadingF1"
                          style="margin-left: 10px"
                          ><svg
                            width="21"
                            height="21"
                            viewBox="0 0 21 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.15531 6.2099L9.44531 3.9099V13.4999C9.44531 13.7651 9.55067 14.0195 9.73821 14.207C9.92574 14.3945 10.1801 14.4999 10.4453 14.4999C10.7105 14.4999 10.9649 14.3945 11.1524 14.207C11.34 14.0195 11.4453 13.7651 11.4453 13.4999V3.9099L13.7353 6.2099C13.8283 6.30363 13.9389 6.37802 14.0607 6.42879C14.1826 6.47956 14.3133 6.50569 14.4453 6.50569C14.5773 6.50569 14.708 6.47956 14.8299 6.42879C14.9517 6.37802 15.0623 6.30363 15.1553 6.2099C15.249 6.11693 15.3234 6.00633 15.3742 5.88447C15.425 5.76261 15.4511 5.63191 15.4511 5.4999C15.4511 5.36788 15.425 5.23718 15.3742 5.11532C15.3234 4.99346 15.249 4.88286 15.1553 4.7899L11.1553 0.789896C11.0602 0.698856 10.9481 0.627491 10.8253 0.579896C10.5819 0.479878 10.3088 0.479878 10.0653 0.579896C9.94256 0.627491 9.83042 0.698856 9.73531 0.789896L5.73531 4.7899C5.64207 4.88313 5.56811 4.99383 5.51765 5.11565C5.46719 5.23747 5.44122 5.36804 5.44122 5.4999C5.44122 5.63176 5.46719 5.76232 5.51765 5.88415C5.56811 6.00597 5.64207 6.11666 5.73531 6.2099C5.82855 6.30313 5.93924 6.3771 6.06106 6.42756C6.18289 6.47802 6.31345 6.50399 6.44531 6.50399C6.57717 6.50399 6.70774 6.47802 6.82956 6.42756C6.95138 6.3771 7.06207 6.30313 7.15531 6.2099ZM19.4453 10.4999C19.1801 10.4999 18.9257 10.6053 18.7382 10.7928C18.5507 10.9803 18.4453 11.2347 18.4453 11.4999V17.4999C18.4453 17.7651 18.34 18.0195 18.1524 18.207C17.9649 18.3945 17.7105 18.4999 17.4453 18.4999H3.44531C3.1801 18.4999 2.92574 18.3945 2.73821 18.207C2.55067 18.0195 2.44531 17.7651 2.44531 17.4999V11.4999C2.44531 11.2347 2.33996 10.9803 2.15242 10.7928C1.96488 10.6053 1.71053 10.4999 1.44531 10.4999C1.1801 10.4999 0.925742 10.6053 0.738206 10.7928C0.550669 10.9803 0.445313 11.2347 0.445312 11.4999V17.4999C0.445313 18.2955 0.761383 19.0586 1.32399 19.6212C1.8866 20.1838 2.64966 20.4999 3.44531 20.4999H17.4453C18.241 20.4999 19.004 20.1838 19.5666 19.6212C20.1292 19.0586 20.4453 18.2955 20.4453 17.4999V11.4999C20.4453 11.2347 20.34 10.9803 20.1524 10.7928C19.9649 10.6053 19.7105 10.4999 19.4453 10.4999Z"
                              fill="#fff"
                            /></svg
                        ></span>
                      </argon-button>
                      <p>
                        <strong>
                          Skan/wyciąg z KRS lub inne dokumenty i pełnomocnictwa
                          do reprezentacji organizacji: *</strong
                        >
                      </p>
                      <input
                        type="file"
                        style="display: none"
                        ref="fileInput2"
                        accept="image/jpeg, application/pdf"
                        @change="onFilePicked($event, 2)"
                      />
                      <p v-if="item.documents.krsScanId">
                        Plik dodany!
                        <a
                          style="float: right"
                          href="#"
                          @click="item.documents.krsScanId = null"
                        >
                          <svg
                            width="18"
                            height="21"
                            viewBox="0 0 18 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7 16.7207C7.26522 16.7207 7.51957 16.6153 7.70711 16.4278C7.89464 16.2403 8 15.9859 8 15.7207V9.7207C8 9.45549 7.89464 9.20113 7.70711 9.0136C7.51957 8.82606 7.26522 8.7207 7 8.7207C6.73478 8.7207 6.48043 8.82606 6.29289 9.0136C6.10536 9.20113 6 9.45549 6 9.7207V15.7207C6 15.9859 6.10536 16.2403 6.29289 16.4278C6.48043 16.6153 6.73478 16.7207 7 16.7207ZM17 4.7207H13V3.7207C13 2.92505 12.6839 2.16199 12.1213 1.59938C11.5587 1.03677 10.7956 0.720703 10 0.720703H8C7.20435 0.720703 6.44129 1.03677 5.87868 1.59938C5.31607 2.16199 5 2.92505 5 3.7207V4.7207H1C0.734784 4.7207 0.48043 4.82606 0.292893 5.0136C0.105357 5.20113 0 5.45549 0 5.7207C0 5.98592 0.105357 6.24027 0.292893 6.42781C0.48043 6.61535 0.734784 6.7207 1 6.7207H2V17.7207C2 18.5164 2.31607 19.2794 2.87868 19.842C3.44129 20.4046 4.20435 20.7207 5 20.7207H13C13.7956 20.7207 14.5587 20.4046 15.1213 19.842C15.6839 19.2794 16 18.5164 16 17.7207V6.7207H17C17.2652 6.7207 17.5196 6.61535 17.7071 6.42781C17.8946 6.24027 18 5.98592 18 5.7207C18 5.45549 17.8946 5.20113 17.7071 5.0136C17.5196 4.82606 17.2652 4.7207 17 4.7207ZM7 3.7207C7 3.45549 7.10536 3.20113 7.29289 3.0136C7.48043 2.82606 7.73478 2.7207 8 2.7207H10C10.2652 2.7207 10.5196 2.82606 10.7071 3.0136C10.8946 3.20113 11 3.45549 11 3.7207V4.7207H7V3.7207ZM14 17.7207C14 17.9859 13.8946 18.2403 13.7071 18.4278C13.5196 18.6153 13.2652 18.7207 13 18.7207H5C4.73478 18.7207 4.48043 18.6153 4.29289 18.4278C4.10536 18.2403 4 17.9859 4 17.7207V6.7207H14V17.7207ZM11 16.7207C11.2652 16.7207 11.5196 16.6153 11.7071 16.4278C11.8946 16.2403 12 15.9859 12 15.7207V9.7207C12 9.45549 11.8946 9.20113 11.7071 9.0136C11.5196 8.82606 11.2652 8.7207 11 8.7207C10.7348 8.7207 10.4804 8.82606 10.2929 9.0136C10.1054 9.20113 10 9.45549 10 9.7207V15.7207C10 15.9859 10.1054 16.2403 10.2929 16.4278C10.4804 16.6153 10.7348 16.7207 11 16.7207Z"
                              fill="#F5365C"
                            /></svg
                        ></a>
                      </p>
                      <argon-button
                        v-if="!item.documents.krsScanId"
                        full-width
                        color="dark"
                        variant="gradient"
                        class="ma-4"
                        @click.prevent="addKrsScan"
                        ><div
                          class="loader"
                          v-if="isLoadingF2"
                          style="min-height: initial"
                        >
                          <pulse-loader
                            :loading="isLoadingF2"
                            color="#fff"
                          ></pulse-loader>
                        </div>
                        <span class="btn-inner--text" v-if="!isLoadingF2"
                          >Dodaj plik z komputera</span
                        >
                        <span
                          class="btn-inner--icon"
                          v-if="!isLoadingF2"
                          style="margin-left: 10px"
                          ><svg
                            width="21"
                            height="21"
                            viewBox="0 0 21 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.15531 6.2099L9.44531 3.9099V13.4999C9.44531 13.7651 9.55067 14.0195 9.73821 14.207C9.92574 14.3945 10.1801 14.4999 10.4453 14.4999C10.7105 14.4999 10.9649 14.3945 11.1524 14.207C11.34 14.0195 11.4453 13.7651 11.4453 13.4999V3.9099L13.7353 6.2099C13.8283 6.30363 13.9389 6.37802 14.0607 6.42879C14.1826 6.47956 14.3133 6.50569 14.4453 6.50569C14.5773 6.50569 14.708 6.47956 14.8299 6.42879C14.9517 6.37802 15.0623 6.30363 15.1553 6.2099C15.249 6.11693 15.3234 6.00633 15.3742 5.88447C15.425 5.76261 15.4511 5.63191 15.4511 5.4999C15.4511 5.36788 15.425 5.23718 15.3742 5.11532C15.3234 4.99346 15.249 4.88286 15.1553 4.7899L11.1553 0.789896C11.0602 0.698856 10.9481 0.627491 10.8253 0.579896C10.5819 0.479878 10.3088 0.479878 10.0653 0.579896C9.94256 0.627491 9.83042 0.698856 9.73531 0.789896L5.73531 4.7899C5.64207 4.88313 5.56811 4.99383 5.51765 5.11565C5.46719 5.23747 5.44122 5.36804 5.44122 5.4999C5.44122 5.63176 5.46719 5.76232 5.51765 5.88415C5.56811 6.00597 5.64207 6.11666 5.73531 6.2099C5.82855 6.30313 5.93924 6.3771 6.06106 6.42756C6.18289 6.47802 6.31345 6.50399 6.44531 6.50399C6.57717 6.50399 6.70774 6.47802 6.82956 6.42756C6.95138 6.3771 7.06207 6.30313 7.15531 6.2099ZM19.4453 10.4999C19.1801 10.4999 18.9257 10.6053 18.7382 10.7928C18.5507 10.9803 18.4453 11.2347 18.4453 11.4999V17.4999C18.4453 17.7651 18.34 18.0195 18.1524 18.207C17.9649 18.3945 17.7105 18.4999 17.4453 18.4999H3.44531C3.1801 18.4999 2.92574 18.3945 2.73821 18.207C2.55067 18.0195 2.44531 17.7651 2.44531 17.4999V11.4999C2.44531 11.2347 2.33996 10.9803 2.15242 10.7928C1.96488 10.6053 1.71053 10.4999 1.44531 10.4999C1.1801 10.4999 0.925742 10.6053 0.738206 10.7928C0.550669 10.9803 0.445313 11.2347 0.445312 11.4999V17.4999C0.445313 18.2955 0.761383 19.0586 1.32399 19.6212C1.8866 20.1838 2.64966 20.4999 3.44531 20.4999H17.4453C18.241 20.4999 19.004 20.1838 19.5666 19.6212C20.1292 19.0586 20.4453 18.2955 20.4453 17.4999V11.4999C20.4453 11.2347 20.34 10.9803 20.1524 10.7928C19.9649 10.6053 19.7105 10.4999 19.4453 10.4999Z"
                              fill="#fff"
                            /></svg
                        ></span>
                      </argon-button>
                      <p><strong>Skan statutu *</strong></p>
                      <input
                        type="file"
                        style="display: none"
                        ref="fileInput3"
                        accept="image/jpeg, application/pdf"
                        @change="onFilePicked($event, 3)"
                      />
                      <p v-if="item.documents.statuteScanId">
                        Plik dodany!
                        <a
                          style="float: right"
                          href="#"
                          @click="item.documents.statuteScanId = null"
                        >
                          <svg
                            width="18"
                            height="21"
                            viewBox="0 0 18 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7 16.7207C7.26522 16.7207 7.51957 16.6153 7.70711 16.4278C7.89464 16.2403 8 15.9859 8 15.7207V9.7207C8 9.45549 7.89464 9.20113 7.70711 9.0136C7.51957 8.82606 7.26522 8.7207 7 8.7207C6.73478 8.7207 6.48043 8.82606 6.29289 9.0136C6.10536 9.20113 6 9.45549 6 9.7207V15.7207C6 15.9859 6.10536 16.2403 6.29289 16.4278C6.48043 16.6153 6.73478 16.7207 7 16.7207ZM17 4.7207H13V3.7207C13 2.92505 12.6839 2.16199 12.1213 1.59938C11.5587 1.03677 10.7956 0.720703 10 0.720703H8C7.20435 0.720703 6.44129 1.03677 5.87868 1.59938C5.31607 2.16199 5 2.92505 5 3.7207V4.7207H1C0.734784 4.7207 0.48043 4.82606 0.292893 5.0136C0.105357 5.20113 0 5.45549 0 5.7207C0 5.98592 0.105357 6.24027 0.292893 6.42781C0.48043 6.61535 0.734784 6.7207 1 6.7207H2V17.7207C2 18.5164 2.31607 19.2794 2.87868 19.842C3.44129 20.4046 4.20435 20.7207 5 20.7207H13C13.7956 20.7207 14.5587 20.4046 15.1213 19.842C15.6839 19.2794 16 18.5164 16 17.7207V6.7207H17C17.2652 6.7207 17.5196 6.61535 17.7071 6.42781C17.8946 6.24027 18 5.98592 18 5.7207C18 5.45549 17.8946 5.20113 17.7071 5.0136C17.5196 4.82606 17.2652 4.7207 17 4.7207ZM7 3.7207C7 3.45549 7.10536 3.20113 7.29289 3.0136C7.48043 2.82606 7.73478 2.7207 8 2.7207H10C10.2652 2.7207 10.5196 2.82606 10.7071 3.0136C10.8946 3.20113 11 3.45549 11 3.7207V4.7207H7V3.7207ZM14 17.7207C14 17.9859 13.8946 18.2403 13.7071 18.4278C13.5196 18.6153 13.2652 18.7207 13 18.7207H5C4.73478 18.7207 4.48043 18.6153 4.29289 18.4278C4.10536 18.2403 4 17.9859 4 17.7207V6.7207H14V17.7207ZM11 16.7207C11.2652 16.7207 11.5196 16.6153 11.7071 16.4278C11.8946 16.2403 12 15.9859 12 15.7207V9.7207C12 9.45549 11.8946 9.20113 11.7071 9.0136C11.5196 8.82606 11.2652 8.7207 11 8.7207C10.7348 8.7207 10.4804 8.82606 10.2929 9.0136C10.1054 9.20113 10 9.45549 10 9.7207V15.7207C10 15.9859 10.1054 16.2403 10.2929 16.4278C10.4804 16.6153 10.7348 16.7207 11 16.7207Z"
                              fill="#F5365C"
                            /></svg
                        ></a>
                      </p>
                      <argon-button
                        v-if="!item.documents.statuteScanId"
                        full-width
                        color="dark"
                        variant="gradient"
                        class="ma-4"
                        @click.prevent="addStatuteScan"
                        ><div
                          class="loader"
                          v-if="isLoadingF3"
                          style="min-height: initial"
                        >
                          <pulse-loader
                            :loading="isLoadingF3"
                            color="#fff"
                          ></pulse-loader>
                        </div>
                        <span class="btn-inner--text" v-if="!isLoadingF3"
                          >Dodaj plik z komputera</span
                        >
                        <span
                          class="btn-inner--icon"
                          v-if="!isLoadingF3"
                          style="margin-left: 10px"
                          ><svg
                            width="21"
                            height="21"
                            viewBox="0 0 21 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.15531 6.2099L9.44531 3.9099V13.4999C9.44531 13.7651 9.55067 14.0195 9.73821 14.207C9.92574 14.3945 10.1801 14.4999 10.4453 14.4999C10.7105 14.4999 10.9649 14.3945 11.1524 14.207C11.34 14.0195 11.4453 13.7651 11.4453 13.4999V3.9099L13.7353 6.2099C13.8283 6.30363 13.9389 6.37802 14.0607 6.42879C14.1826 6.47956 14.3133 6.50569 14.4453 6.50569C14.5773 6.50569 14.708 6.47956 14.8299 6.42879C14.9517 6.37802 15.0623 6.30363 15.1553 6.2099C15.249 6.11693 15.3234 6.00633 15.3742 5.88447C15.425 5.76261 15.4511 5.63191 15.4511 5.4999C15.4511 5.36788 15.425 5.23718 15.3742 5.11532C15.3234 4.99346 15.249 4.88286 15.1553 4.7899L11.1553 0.789896C11.0602 0.698856 10.9481 0.627491 10.8253 0.579896C10.5819 0.479878 10.3088 0.479878 10.0653 0.579896C9.94256 0.627491 9.83042 0.698856 9.73531 0.789896L5.73531 4.7899C5.64207 4.88313 5.56811 4.99383 5.51765 5.11565C5.46719 5.23747 5.44122 5.36804 5.44122 5.4999C5.44122 5.63176 5.46719 5.76232 5.51765 5.88415C5.56811 6.00597 5.64207 6.11666 5.73531 6.2099C5.82855 6.30313 5.93924 6.3771 6.06106 6.42756C6.18289 6.47802 6.31345 6.50399 6.44531 6.50399C6.57717 6.50399 6.70774 6.47802 6.82956 6.42756C6.95138 6.3771 7.06207 6.30313 7.15531 6.2099ZM19.4453 10.4999C19.1801 10.4999 18.9257 10.6053 18.7382 10.7928C18.5507 10.9803 18.4453 11.2347 18.4453 11.4999V17.4999C18.4453 17.7651 18.34 18.0195 18.1524 18.207C17.9649 18.3945 17.7105 18.4999 17.4453 18.4999H3.44531C3.1801 18.4999 2.92574 18.3945 2.73821 18.207C2.55067 18.0195 2.44531 17.7651 2.44531 17.4999V11.4999C2.44531 11.2347 2.33996 10.9803 2.15242 10.7928C1.96488 10.6053 1.71053 10.4999 1.44531 10.4999C1.1801 10.4999 0.925742 10.6053 0.738206 10.7928C0.550669 10.9803 0.445313 11.2347 0.445312 11.4999V17.4999C0.445313 18.2955 0.761383 19.0586 1.32399 19.6212C1.8866 20.1838 2.64966 20.4999 3.44531 20.4999H17.4453C18.241 20.4999 19.004 20.1838 19.5666 19.6212C20.1292 19.0586 20.4453 18.2955 20.4453 17.4999V11.4999C20.4453 11.2347 20.34 10.9803 20.1524 10.7928C19.9649 10.6053 19.7105 10.4999 19.4453 10.4999Z"
                              fill="#fff"
                            /></svg
                        ></span>
                      </argon-button>
                      <div class="errors" v-if="submitted3">
                        <p
                          v-if="
                            !this.item.documents.krsScanId ||
                            !this.item.documents.bankAccountStatementId ||
                            !this.item.documents.statuteScanId
                          "
                        >
                          Dodaj wszystkie pliki!
                        </p>
                      </div>
                    </div>
                  </tab-content>
                  <tab-content title="Dane osobowe">
                    <div class="col-6 offset-3">
                      <p>
                        <strong
                          >Osoby upoważnione do składania oświadczeń woli:
                        </strong>
                      </p>
                      <argon-input
                        type="text"
                        placeholder="Imię i nazwisko*"
                        v-model="
                          v$.item.personalDataList
                            .personsAuthorizedToMakeDeclarationsOfIntents[0]
                            .name.$model
                        "
                        :v="
                          v$.item.personalDataList
                            .personsAuthorizedToMakeDeclarationsOfIntents[0]
                            .name
                        "
                        :submitted="submitted4"
                      />
                      <argon-input
                        type="text"
                        placeholder="Stanowisko*"
                        v-model="
                          v$.item.personalDataList
                            .personsAuthorizedToMakeDeclarationsOfIntents[0]
                            .jobPosition.$model
                        "
                        :v="
                          v$.item.personalDataList
                            .personsAuthorizedToMakeDeclarationsOfIntents[0]
                            .jobPosition
                        "
                        :submitted="submitted4"
                      />

                      <argon-input
                        type="email"
                        placeholder="Adres e-mail*"
                        v-model="
                          v$.item.personalDataList
                            .personsAuthorizedToMakeDeclarationsOfIntents[0]
                            .emailAddress.$model
                        "
                        :v="
                          v$.item.personalDataList
                            .personsAuthorizedToMakeDeclarationsOfIntents[0]
                            .emailAddress
                        "
                        :submitted="submitted4"
                      />
                      <argon-input
                        type="text"
                        placeholder="Numer telefonu*"
                        v-model="
                          v$.item.personalDataList
                            .personsAuthorizedToMakeDeclarationsOfIntents[0]
                            .phoneNumber.$model
                        "
                        :v="
                          v$.item.personalDataList
                            .personsAuthorizedToMakeDeclarationsOfIntents[0]
                            .phoneNumber
                        "
                        :submitted="submitted4"
                      />
                      <hr />
                      <p><strong>Osoby do kontaktu: </strong></p>
                      <div class="form-check" style="margin-bottom: 20px">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="copyData"
                          name="copyData"
                          v-model="item.copyData"
                          @change="copyPersonalData()"
                        />

                        <label class="form-check-label" for="copyData">
                          Takie same jak osoba upoważniona do składania
                          oświadczeń woli
                        </label>
                      </div>
                      <argon-input
                        type="text"
                        placeholder="Imię i nazwisko*"
                        v-model="
                          v$.item.personalDataList.contactInfoList[0].name
                            .$model
                        "
                        :v="v$.item.personalDataList.contactInfoList[0].name"
                        :submitted="submitted4"
                        :disabled="item.copyData"
                      />
                      <argon-input
                        type="text"
                        placeholder="Stanowisko*"
                        v-model="
                          v$.item.personalDataList.contactInfoList[0]
                            .jobPosition.$model
                        "
                        :v="
                          v$.item.personalDataList.contactInfoList[0]
                            .jobPosition
                        "
                        :submitted="submitted4"
                        :disabled="item.copyData"
                      />

                      <argon-input
                        type="email"
                        placeholder="Adres e-mail*"
                        v-model="
                          v$.item.personalDataList.contactInfoList[0]
                            .emailAddress.$model
                        "
                        :v="
                          v$.item.personalDataList.contactInfoList[0]
                            .emailAddress
                        "
                        :submitted="submitted4"
                        :disabled="item.copyData"
                      />
                      <argon-input
                        type="text"
                        placeholder="Numer telefonu*"
                        v-model="
                          v$.item.personalDataList.contactInfoList[0]
                            .phoneNumber.$model
                        "
                        :v="
                          v$.item.personalDataList.contactInfoList[0]
                            .phoneNumber
                        "
                        :submitted="submitted4"
                        :disabled="item.copyData"
                      />
                    </div>
                  </tab-content>

                  <template v-slot:footer="props">
                    <div class="wizard-footer-left">
                      <wizard-button
                        v-if="props.activeTabIndex > 0 && !props.isLastStep"
                        @click="props.prevTab()"
                        :style="props.fillButtonStyle"
                        >Wróć</wizard-button
                      >
                    </div>
                    <div class="wizard-footer-right">
                      <wizard-button
                        v-if="!props.isLastStep"
                        @click="props.nextTab()"
                        class="wizard-footer-right"
                        :style="props.fillButtonStyle"
                        >Dalej</wizard-button
                      >

                      <wizard-button
                        v-else
                        @click="onComplete"
                        class="wizard-footer-right finish-button"
                        :style="props.fillButtonStyle"
                      >
                        {{
                          props.isLastStep ? "Utwórz organizację" : "Dalej"
                        }}</wizard-button
                      >
                    </div>
                  </template>
                </form-wizard>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="alert fixed-right alert-danger alert-dismissible fade show"
      role="alert"
      v-if="responseError"
    >
      <span class="alert-text"
        ><strong>Error!</strong>{{ responseErrorText }}</span
      >
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="alert"
        aria-label="Close"
        @click="responseError = false"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import axios from "axios";
import ArgonInput from "@/components/ArgonInput.vue";
import useValidate from "@vuelidate/core";
import {
  required,
  minLength,
  maxLength,
  email,
  numeric,
  helpers,
} from "@vuelidate/validators";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

const myMaxLength = (max) =>
  helpers.withMessage(`Twoje pole jest za długie`, maxLength(max));

const myMinLength = (min) =>
  helpers.withMessage(`Twoje pole jest za krótkie`, minLength(min));

const regon = helpers.regex(/^(\d{9}|\d{14})$/);

export default {
  name: "wizard",
  components: {
    ArgonInput,
    ArgonButton,
    PulseLoader,
  },
  data() {
    return {
      copyData: false,
      submitted: false,
      submitted2: false,
      submitted3: false,
      submitted4: false,
      v$: useValidate(),
      responseError: false,
      responseErrorText: "",
      isLoading: false,
      isLoadingF1: false,
      isLoadingF2: false,
      isLoadingF3: false,
      picked: "",
      itemTest: {
        generalInfo: {
          legalForm: { legalFormEnum: 1 },
          scopeOfActivities: 1,
          name: "Nazwaaaa",
          taxId: "432423432",
          regon: "43423432432",
          krs: "4324324234",
          bankAccountNumber: "432432234432423423423432342",
          description: "",
        },
        contactInfo: {
          countryId: 1,
          street: "dasdasdsa",
          postalCode: "4214324",
          city: "dasasddasdas",
          region: "dasdsadasd",
          emailAddress: "zymla.lukasz@gmail.com",
          webAddress: "dasdasdas",
          phoneNumber: "342423423",
        },
        documents: {
          bankAccountStatementId: 13,
          krsScanId: 14,
          statuteScanId: 15,
        },
        personalDataList: {
          personsAuthorizedToMakeDeclarationsOfIntents: [
            {
              name: "dsadasdas",
              jobPosition: "dasdasdsa",
              emailAddress: "zymla.lukasz@gmail.com",
              phoneNumber: "3423432432",
            },
          ],
          contactInfoList: [
            { name: "", jobPosition: "", emailAddress: "", phoneNumber: "" },
          ],
        },
        copyData: true,
      },
      nipRules: [
        (v) => !!v || "NIP jest wymagany",
        (v) => (v && v.length >= 9) || "NIP musi posiadać minimalnie 9 znaków",
        (v) =>
          (v && v.length <= 14) || "NIP musi posiadać maksymalnie 14 znaków",
      ],
      item: {
        generalInfo: {
          legalForm: { legalFormEnum: 1 },
          scopeOfActivities: 1,
        },
        contactInfo: { countryId: 1 },
        documents: {
          bankAccountStatementId: null,
          krsScanId: null,
          statuteScanId: null,
        },
        personalDataList: {
          personsAuthorizedToMakeDeclarationsOfIntents: [{}],
          contactInfoList: [{}],
        },
      },
      LegalFormEnum: [
        {
          id: 1,
          name: "Association",
          description: "Stowarzyszenie",
        },
        {
          id: 2,
          name: "Foundation",
          description: "Fundacja",
        },
        {
          id: 3,
          name: "Organisation",
          description: "Towarzystwo",
        },
        {
          id: 10,
          name: "Other",
          description: "Inne",
        },
      ],
      contractorScopeOfActivitiesEnums: [
        {
          id: 1,
          name: "Local",
          description: "lokalny",
        },
        {
          id: 2,
          name: "Regional",
          description: "wojewódzki",
        },
        {
          id: 3,
          name: "National",
          description: "ogólnopolski",
        },
        {
          id: 10,
          name: "International",
          description: "międzynarodowy",
        },
      ],
    };
  },
  validations() {
    return {
      item: {
        generalInfo: {
          name: {
            required: helpers.withMessage("To pole jest wymagane", required),
            minLength: myMinLength(2),
            maxLength: myMaxLength(128),
            $lazy: true,
          },
          taxId: {
            required: helpers.withMessage("To pole jest wymagane", required),
            minLength: myMinLength(9),
            maxLength: myMaxLength(14),
          },
          regon: {
            required: helpers.withMessage("To pole jest wymagane", required),
            regon: helpers.withMessage(
              "Regon musi zawierać 9 lub 14 znaków",
              regon
            ),
            numeric: helpers.withMessage("Dopuszcalne tylko cyfry", numeric),
          },
          krs: {
            required: helpers.withMessage("To pole jest wymagane", required),
            minLength: myMinLength(10),
            maxLength: myMaxLength(10),
            numeric,
          },
          bankAccountNumber: {
            required: helpers.withMessage("To pole jest wymagane", required),
            minLength: myMinLength(26),
            maxLength: myMaxLength(30),
            numeric,
          },
        },
        contactInfo: {
          street: {
            required: helpers.withMessage("To pole jest wymagane", required),
            minLength: myMinLength(3),
            maxLength: myMaxLength(255),
          },
          postalCode: {
            required: helpers.withMessage("To pole jest wymagane", required),
            minLength: myMinLength(5),
            maxLength: myMaxLength(12),
          },
          city: {
            required: helpers.withMessage("To pole jest wymagane", required),
            minLength: myMinLength(3),
            maxLength: myMaxLength(255),
          },
          region: {
            required: helpers.withMessage("To pole jest wymagane", required),
            minLength: myMinLength(3),
            maxLength: myMaxLength(255),
          },
          emailAddress: {
            required: helpers.withMessage("To pole jest wymagane", required),
            email,
          },
          webAddress: {
            required: helpers.withMessage("To pole jest wymagane", required),
            minLength: myMinLength(5),
            maxLength: myMaxLength(255),
          },
          phoneNumber: {
            required: helpers.withMessage("To pole jest wymagane", required),
            minLength: myMinLength(9),
            maxLength: myMaxLength(20),
          },
        },

        personalDataList: {
          personsAuthorizedToMakeDeclarationsOfIntents: [
            {
              name: {
                required: helpers.withMessage(
                  "To pole jest wymagane",
                  required
                ),
                minLength: myMinLength(3),
                maxLength: myMaxLength(100),
              },
              jobPosition: {
                required: helpers.withMessage(
                  "To pole jest wymagane",
                  required
                ),
                minLength: myMinLength(3),
                maxLength: myMaxLength(100),
              },
              phoneNumber: {
                required: helpers.withMessage(
                  "To pole jest wymagane",
                  required
                ),
                minLength: myMinLength(9),
                maxLength: myMaxLength(20),
              },
              emailAddress: {
                required: helpers.withMessage(
                  "To pole jest wymagane",
                  required
                ),
                email,
              },
            },
          ],
          contactInfoList: [
            {
              name: {
                required: helpers.withMessage(
                  "To pole jest wymagane",
                  required
                ),
                minLength: myMinLength(3),
                maxLength: myMaxLength(100),
              },
              jobPosition: {
                required: helpers.withMessage(
                  "To pole jest wymagane",
                  required
                ),
                minLength: myMinLength(3),
                maxLength: myMaxLength(100),
              },
              phoneNumber: {
                required: helpers.withMessage(
                  "To pole jest wymagane",
                  required
                ),
                minLength: myMinLength(9),
                maxLength: myMaxLength(20),
              },
              emailAddress: {
                required: helpers.withMessage(
                  "To pole jest wymagane",
                  required
                ),
                email,
              },
            },
          ],
        },
      },
    };
  },
  created() {
    //this.getUsers();
  },
  mounted() {
    this.v$.$touch();
  },
  methods: {
    copyPersonalData() {
      if (!this.copyData) {
        this.v$.item.personalDataList.contactInfoList[0].emailAddress.$model =
          this.v$.item.personalDataList.personsAuthorizedToMakeDeclarationsOfIntents[0].emailAddress.$model;
        this.v$.item.personalDataList.contactInfoList[0].jobPosition.$model =
          this.v$.item.personalDataList.personsAuthorizedToMakeDeclarationsOfIntents[0].jobPosition.$model;
        this.v$.item.personalDataList.contactInfoList[0].name.$model =
          this.v$.item.personalDataList.personsAuthorizedToMakeDeclarationsOfIntents[0].name.$model;
        this.v$.item.personalDataList.contactInfoList[0].phoneNumber.$model =
          this.v$.item.personalDataList.personsAuthorizedToMakeDeclarationsOfIntents[0].phoneNumber.$model;
      }
    },

    onFilePicked(event, type) {
      console.log("this.onFilePicked");

      const files = event.target.files;
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.imageUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.uploadFile(type, files[0]);
    },

    addBankAccountStatement() {
      this.isLoadingF1 = true;
      this.$refs.fileInput.click();
    },
    addKrsScan() {
      this.isLoadingF2 = true;
      this.$refs.fileInput2.click();
    },
    addStatuteScan() {
      this.isLoadingF3 = true;
      this.$refs.fileInput3.click();
    },
    onComplete: function () {
      this.isLoading = true;
      this.submitted4 = true;
      this.v$.item.personalDataList.$touch();

      if (this.v$.item.personalDataList.$invalid) {
        this.isLoading = false;
        return;
      } else {
        axios
          .post(
            process.env.VUE_APP_BACK_OFFICE_API_URL +
              "Contractor/CreateFoundationContractor",
            this.item,
            {
              headers: {
                Authorization: "Bearer " + sessionStorage.getItem("token"),
              },
            }
          )
          .then((res) => {
            console.log(res);
            this.isLoading = true;
            this.$router.push({ name: "Dashboard" });
          })
          .catch((err) => {
            this.isLoading = false;
            this.responseError = true;
            this.responseErrorText = err.response.data;
            console.log(err);
          });
      }
    },
    uploadFile(type, file) {
      let formData = new FormData();

      formData.append("Content", file);
      formData.append("DocumentType", type);

      axios
        .post(
          process.env.VUE_APP_BACK_OFFICE_API_URL + "Document/Upload",
          formData,
          {
            headers: {
              Authorization: "Bearer " + sessionStorage.getItem("token"),
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          console.log(res);
          console.log(res.data.id);
          if (type == 1) {
            this.item.documents.bankAccountStatementId = res.data.id;
            this.isLoadingF1 = false;
          } else if (type == 2) {
            this.item.documents.krsScanId = res.data.id;
            this.isLoadingF2 = false;
          } else {
            this.item.documents.statuteScanId = res.data.id;
            this.isLoadingF3 = false;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.responseError = true;
          this.responseErrorText = err.response.data;
          console.log(err);
        });
    },
    status(validation) {
      return {
        "is-invalid": validation.$error,
        dirty: validation.$dirty,
        touch: validation.$touch,
      };
    },
    beforeTabSwitch: function () {
      console.log("beforeTabSwitch");
      this.submitted = true;
      this.v$.item.generalInfo.$touch();
      let flag = false;

      if (this.v$.item.generalInfo.$invalid) {
        flag = false;
      } else {
        flag = true;
      }
      return flag;
    },
    beforeTabSwitch2: function () {
      console.log("beforeTabSwitch");
      this.submitted2 = true;
      this.v$.item.contactInfo.$touch();
      let flag = false;

      if (this.v$.item.contactInfo.$invalid) {
        flag = false;
      } else {
        flag = true;
      }
      return flag;
    },
    beforeTabSwitch3: function () {
      this.submitted3 = true;
      this.v$.item.contactInfo.$touch();
      let flag = false;

      if (
        this.item.documents.krsScanId &&
        this.item.documents.bankAccountStatementId &&
        this.item.documents.statuteScanId
      ) {
        flag = true;
      } else {
        flag = false;
      }
      return flag;
    },
  },
};
</script>

<style>
.vue-form-wizard.md .wizard-icon-circle {
  width: 16px;
  height: 16px;
  font-size: 24px;
  background-color: #172b4d !important;
  border-color: #172b4d !important;
}

.vue-form-wizard.md .disabled .wizard-icon-circle {
  border-color: #dee2e6 !important;
  background: #dee2e6 !important;
}

.vue-form-wizard.md .wizard-icon-circle i {
  display: none !important;
}

.vue-form-wizard.md .wizard-navigation .wizard-progress-with-circle {
  top: 12px;
  height: 2px;
  background: #dee2e6;
}

.vue-form-wizard
  .wizard-navigation
  .wizard-progress-with-circle
  .wizard-progress-bar {
  background-color: #172b4d !important;
}

.wizard-icon-circle.checked .wizard-icon-container {
  background-color: #172b4d !important;
}

.stepTitle {
  color: #dee2e6 !important;
  font-size: 14px;
  font-weight: 600;
}

.stepTitle.active {
  color: #172b4d !important;
}

.wizard-btn {
  background-color: #172b4d !important;
  border-color: #172b4d !important;
}

.files p {
  margin-top: 50px;
}
</style>